<div class="poll-holder" (click)="openPoll($event)">
  <h5 class="item-title bold dark-blue no-margin text-md">{{pollData.title}}</h5>
  <div *ngIf="column == 3" class="status-finished mt-10 mb-10"></div>
  <div *ngIf="column == 2" class="status-ongoing mt-10 mb-10"></div>
  <div *ngIf="column == 1" class="status-planned mt-10 mb-10"></div>
  <div *ngIf="column == 0" class="status-draft mt-10 mb-10"></div>
  <div class="calendar-holder">
    <div class="flex flex-column gap-5" style="margin-top: -5px;">
      <img src="assets/calendar25.svg" height="14" width="14" id="voters-icon">
      <img src="assets/clock.svg" height="14" width="14" id="voters-icon">
    </div>
    <h5 class="date text-xs dark-blue no-margin" style="line-height: 18px;">
      <!-- {{startDate}} - {{endDate}} -->
      {{dates}}
    </h5>
  </div>
  <div *ngIf="column !== 2" class="button-holder">
    <img src="assets/clone.svg" data-cy="clone_button" (click)="cloneAction()"
      title="{{'HOME.GENERAL.CLONE-BUTTON' | translate}}" class="clone-icon">
    <img *ngIf="column === 1 && super" src="assets/warning.svg" (click)="exportAction()" class="export-icon">
    <img *ngIf="!hideEditButton" src="assets/edit_icon.svg" (click)="editPopup()" height="20" width="20" id="edit-icon">
    <img src="assets/delete_icon.svg" data-cy="delete_button" (click)="deletePopup()" height="20" width="20"
      id="delete-icon" title="{{'HOME.GENERAL.DELETE-BUTTON' | translate}}">
  </div>
  <div *ngIf="column ===2" class="button-holder">
    <img src="assets/clone.svg" data-cy="clone_button" (click)="cloneAction()" height="20" width="20"
      class="clone-icon">
    <img *ngIf="super" src="assets/warning.svg" (click)="exportAction()" class="export-icon">
  </div>
</div>
<vc-warning-popup *ngIf="warningPopup" title="{{'POLL-DELETION.COMPLETE' | translate}}" [deleteButton]="true"
  [cancelButton]="true" (endDetailsPopup)="dismissDeletePopup($event)" [separator]="false">
</vc-warning-popup>